module.exports = __webpack_public_path__ + "static/media/The-Ultimate-Guide-to-Car-Engine-Problems.c75d3bcf.jpg";